"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortSizesOptions = void 0;
const sizesOrder = {
    XS: 1,
    SM: 2,
    MD: 3,
    LG: 4,
    XL: 5,
    '2XL': 6
};
const sortSizesOptions = (sizeOptions = [], replacements = {}) => {
    const result = {};
    for (const { label, value } of sizeOptions) {
        if (!result[value]) {
            result[value] = {
                value,
                label: replacements[value] || label
            };
        }
    }
    return Object.values(result).sort((a, b) => {
        let sortValue = 0;
        if (sizesOrder[a.value] && sizesOrder[b.value]) {
            sortValue = sizesOrder[a.value] - sizesOrder[b.value];
        }
        return sortValue;
    });
};
exports.sortSizesOptions = sortSizesOptions;
//# sourceMappingURL=sortSizesOptions.js.map